import React from 'react';
import styled from 'styled-components';
import StyleConfig from 'src/constants/StyleConfig';

interface Props {
  title: string;
}

export const ListTitle = ({ ...props }: Props) => {
  const { title } = props;
  return (
    <Styled>
      <h3 className="title">
        <span>{title}</span>
      </h3>
    </Styled>
  );
};

const Styled = styled.div`
  h3 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: ${StyleConfig.HELPER.M8} auto;
    span {
      font-size: 20px;
      font-weight: bold;
      color: ${StyleConfig.COLOR.PRIMARY};
    }
  }
`;
export default ListTitle;
